module.exports = __webpack_public_path__ + "img/mlt_x.6a90fd7f.jpg";